import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import { LoadingPage } from '@/components/shared/LoadingSpinner'
import Header from './Header'
import Footer from './Footer'
import { MaintenanceBanner } from '@/components/shared/MaintenanceBanner'

export default function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <MaintenanceBanner />
      <Header />
      <main className="flex-1">
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </div>
  )
}
